import { t } from 'i18next';

import { config } from '~/config';

import { htmlNodes } from './htmlNodes';

export const getDisclaimer = () => {
  const disclaimerText = t('chat:lsegDisclaimer');
  const privacyLinkText = t('chat:privacy');
  const privacyLinkUrl = config.urls.lsegStatement;
  const faqsLinkText = t('chat:faqs');
  const faqsLinkUrl = `${config.urls.root}${config.urls.faqs}`;

  const disclaimerTextSpan = `<span style="margin-right: 4px;">${disclaimerText}</span>`;
  const disclaimerLink = htmlNodes.a(privacyLinkText, privacyLinkUrl);
  const andSymbol = `<span style="margin-left: 2px; margin-right: 2px;">${t(
    'chat:andSymbol'
  )}</span>`;
  const faqsLink = htmlNodes.a(faqsLinkText, faqsLinkUrl);
  const disclaimerHtml = `<div style="display: flex; align-items: center; margin-top: 16px; margin-bottom: 16px; font-size: 12px; line-height: 1.4;">${disclaimerTextSpan}${disclaimerLink}${andSymbol}${faqsLink}</div>`;

  return {
    disclaimerHtml,
  };
};
